import styled from 'styled-components'

import { mediaPrintRemoveMargPaddBackg, tableCss } from '../../styles'

export const WrapTableDiv = styled.div`
  ${mediaPrintRemoveMargPaddBackg}
  ${tableCss}
`
